import { Provider, ColumnDataType } from '../types'
import { EnrichComponent } from './common/enrichcomponent'

class QuadbinEnrich extends EnrichComponent {
  constructor() {
    super(
      {
        name: 'native.quadbinenrich',
        group: 'Data Enrichment',
        title: 'Enrich Quadbin Grid',
        description: `
      This component uses a data source (either a table or a DO subscription) to enrich a target Quadbin table.
      `,
        starred: true
      },
      'ENRICH_GRID',
      'quadbin'
    )
    this.gridType = 'quadbin'

    // adapt the input descriptions to the specific command geo type
    let index = this.inputs.findIndex((i) => i.name === 'target')
    this.inputs[index].description = this.inputs[index].title = 'Target Quadbin table'

    index = this.inputs.findIndex((i) => i.name === 'target_col')
    this.inputs[index].description = this.inputs[index].title = 'Target Quadbin column'
    this.inputs[index].dataType = [ColumnDataType.Number]
  }
  supportedProviders(): Provider[] {
    return [Provider.Snowflake, Provider.BigQuery, Provider.Redshift]
  }
}

export { QuadbinEnrich }
